import React, { PureComponent } from 'react'
import { localize } from 'helpers/translator'

class SignUpEmailTermsError extends PureComponent {

	render() {
		if (this.props.meta.error && this.props.meta.touched) {
			return <span className={this.props.style_data}>{localize(this.props.meta.error)}</span>
		} else {
			return null
		}
	}
}

export default SignUpEmailTermsError
